<ion-title class="ion-no-padding">
  @if(storyName()){
  {{ storyName() }}
  <ion-note class="chatName">
    @if (titleKey(); as key) {
    {{ key | translate }}
    } @else {
    {{ name() }}
    }
  </ion-note>
  } @else {
  {{ name() }}
  }
</ion-title>
